import { __read } from 'tslib';
import * as React from 'react';
import classNames from 'classnames';
import { CarouselContext, Dot } from 'pure-react-carousel';
import styles from './CarouselControlIndicator.module.esm.js';
import styles$1 from '../../../blocks/CarouselSection/CarouselSection.module.esm.js';

var CarouselControlIndicator = function (_a) {
    var _b;
    var carouselSkipId = _a.carouselSkipId, carouselItemId = _a.carouselItemId, index = _a.index;
    var carouselContext = React.useContext(CarouselContext);
    var _c = __read(React.useState(carouselContext.state.currentSlide), 2), currentSlide = _c[0], setCurrentSlide = _c[1];
    var isSelected = currentSlide === index;
    React.useEffect(function () {
        function onChange() {
            setCurrentSlide(carouselContext.state.currentSlide);
        }
        carouselContext.subscribe(onChange);
        return function () { return carouselContext.unsubscribe(onChange); };
    }, [carouselContext]);
    return (React.createElement("li", { "aria-hidden": !isSelected, "aria-selected": isSelected, className: styles.controlIndicatorListItem, 
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
        role: "option" },
        React.createElement(Dot, { "aria-label": "", className: styles.controlIndicatorButton, disabled: false, onKeyDown: function (e) {
                if (!['Space', 'Enter'].includes(e.nativeEvent.code))
                    return;
                // if button is keyboard activated takes focus to selected carousel item
                window.location.href = "#".concat(carouselItemId);
            }, slide: index },
            React.createElement(React.Fragment, null,
                React.createElement("span", { className: styles$1.visuallyHidden },
                    "Click to go to carousel item ",
                    index + 1),
                isSelected && React.createElement("span", { className: styles$1.visuallyHidden }, "(Current carousel item)"),
                React.createElement("div", { className: styles.spacer }),
                React.createElement("div", { className: classNames(styles.controlIndicator, (_b = {},
                        _b[styles['controlIndicator--selected']] = isSelected,
                        _b)) }),
                React.createElement("div", { className: styles.spacer }))),
        React.createElement("a", { className: styles$1.visuallyHidden, href: "#".concat(carouselSkipId) }, "Click to skip carousel navigation")));
};

export { CarouselControlIndicator };
//# sourceMappingURL=CarouselControlIndicator.esm.js.map
